import { render, staticRenderFns } from "./BaiduConversationPanel.vue?vue&type=template&id=4d3143be&scoped=true"
import script from "./BaiduConversationPanel.vue?vue&type=script&lang=js"
export * from "./BaiduConversationPanel.vue?vue&type=script&lang=js"
import style0 from "./BaiduConversationPanel.vue?vue&type=style&index=0&id=4d3143be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3143be",
  null
  
)

export default component.exports